import { render, staticRenderFns } from "./why-page.vue?vue&type=template&id=742af9a1&scoped=true&"
import script from "./why-page.vue?vue&type=script&lang=js&"
export * from "./why-page.vue?vue&type=script&lang=js&"
import style0 from "./why-page.vue?vue&type=style&index=0&id=742af9a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742af9a1",
  null
  
)

export default component.exports